/**
 * One-shot cleanup of legacy IndexedDB databases that are no longer used.
 *
 * The React app previously cached metadata + permissions + workflow in a
 * dedicated `rw-erp-cache` database. We now share the Vue ERP's existing
 * `LocalCache` database instead, so the old one is orphaned. This helper
 * deletes it once per browser to free the disk space and avoid confusing
 * developers inspecting DevTools.
 */
const ORPHAN_DB_NAME = 'rw-erp-cache';
const FLAG_KEY = 'rw-erp-cache-cleaned';

export function cleanupOrphanCaches(): void {
  if (typeof window === 'undefined') return;
  if (typeof indexedDB === 'undefined') return;
  if (window.localStorage.getItem(FLAG_KEY) === '1') return;

  try {
    const request = indexedDB.deleteDatabase(ORPHAN_DB_NAME);
    request.onsuccess = () => {
      window.localStorage.setItem(FLAG_KEY, '1');
    };
    request.onerror = () => {
      // Ignore — failure here just means we'll retry on the next page load.
    };
    request.onblocked = () => {
      // Another tab still holds the connection — also fine to retry later.
    };
  } catch {
    // No-op — environment without indexedDB support.
  }
}
